import React from 'react'

function Number() {
  return (
    <span className='cs-data-number'>Number</span>
  )
}

export  {Number}